import React from "react";
import OrderTable from "../Table";

const InvoiceShared = () => {
  return <OrderTable type="Invoice Shared" />;
};

export default InvoiceShared;
